import { components } from "types/openapi";
import { TCommonStatus } from "./statuses";

export type UserCheckDto = components["schemas"]["UserCheckDto"];
export type UserCheckWalletStatus = components["schemas"]["UserCheckDto"]["status"];
export type RequestCheckWalletStatus = components["schemas"]["RequestTxGridDto"]["riskStatus"];
export type WalletRiskLevel = components["schemas"]["UserCheckDto"]["riskLevel"];
export type UserCheckGridDto = components["schemas"]["UserCheckGridDto"];
export type RiskStatus = components["schemas"]["RequestTxGridDto"]["riskStatus"];
export type AutoWalletCheckRequest = components["schemas"]["AutoWalletCheckRequest"];
export type RequestCheckWalletDto = components["schemas"]["RequestCheckWalletDto"];
export type BidAmlStatusCheckResponse = components["schemas"]["AmlCheckStatusDto"];
export type BidWalletOperation = components["schemas"]["AmlCheckStatusDto"]["requestAction"];

export const BID_WALLET_OPERATION_ENUM: Record<BidWalletOperation, BidWalletOperation> = {
  EXECUTE: "EXECUTE",
  APPROVE_REQUEST: "APPROVE_REQUEST",
  FUNDED: "FUNDED",
  ACCEPT_QUOTE: "ACCEPT_QUOTE",
};

export const USER_CHECK_STATUS_ENUM: Record<UserCheckWalletStatus, UserCheckWalletStatus> = {
  INITIAL: "INITIAL",
  WAITING_AML_RESPONSE: "WAITING_AML_RESPONSE",
  COMPLETED: "COMPLETED",
};

export const REQUEST_CHECK_STATUS_ENUM: Record<
  Exclude<components["schemas"]["RequestTxGridDto"]["riskStatus"], undefined>,
  Exclude<components["schemas"]["RequestTxGridDto"]["riskStatus"], undefined>
> = {
  APPROVE_NEEDED: "APPROVE_NEEDED",
  APPROVED: "APPROVED",
  REFUNDED: "REFUNDED",
  REFUNDING: "REFUNDING",
  SUCCESS: "SUCCESS",
  UNDEFINED: "UNDEFINED",
  NOT_USED: "NOT_USED",
  EXPIRED: "EXPIRED",
};

export const RISK_LEVEL_ENUM: Record<Exclude<WalletRiskLevel, undefined>, Exclude<WalletRiskLevel, undefined>> = {
  HIGH: "HIGH",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  NONE: "NONE",
  SEVERE: "SEVERE",
  TIMEOUT: "TIMEOUT",
  UNDEFINED: "UNDEFINED",
};

export const RISK_LEVELS_FILTERS = {
  NONE: "NONE",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  SEVERE: "SEVERE",
  TIMEOUT: "TIMEOUT",
};

export const RISK_LEVELS: TCommonStatus<Exclude<WalletRiskLevel, undefined>> = {
  texts: {
    UNDEFINED: "Не определен",
    NONE: "Отсутствует",
    LOW: "Низкий",
    MEDIUM: "Средний",
    HIGH: "Высокий",
    SEVERE: "Критический",
    TIMEOUT: "Неуспешно",
  },
  colors: {
    UNDEFINED: "gray",
    NONE: "green",
    LOW: "green",
    MEDIUM: "yellow",
    HIGH: "red",
    SEVERE: "red",
    TIMEOUT: "gray",
  },
};

export const RISK_STATUS_ENUM: Record<Exclude<RiskStatus, undefined>, string> = {
  APPROVED: "APPROVED",
  REFUNDED: "REFUNDED",
  REFUNDING: "REFUNDING",
  APPROVE_NEEDED: "APPROVE_NEEDED",
  SUCCESS: "SUCCESS",
  UNDEFINED: "UNDEFINED",
  NOT_USED: "NOT_USED",
  EXPIRED: "EXPIRED",
};

export const RISK_STATUS_TEXTS: Record<Exclude<RiskStatus, undefined>, string> = {
  APPROVED: "Одобрено",
  REFUNDED: "Возвращено",
  REFUNDING: "К возврату",
  APPROVE_NEEDED: "Требует согласования",
  SUCCESS: "Успешно",
  UNDEFINED: "Не определено",
  NOT_USED: "Не использовано",
  EXPIRED: "Истекла",
};

//TODO переписать на типы из interfaces/statuses.ts при рефакторе других гридов
// Сделано для того, чтобы использовать в компоненте RiskTextColor
export const RISK_STATUS_COLORS: Record<
  Exclude<RiskStatus, undefined>,
  "success" | "default" | "warning" | "danger"
> = {
  APPROVED: "success",
  REFUNDED: "danger",
  REFUNDING: "warning",
  APPROVE_NEEDED: "warning",
  SUCCESS: "success",
  UNDEFINED: "default",
  NOT_USED: "default",
  EXPIRED: "default",
};
// Сделано для того, чтобы использовать в компоненте RiskTextColor
export const RISK_LEVEL_COLORS: Record<
  Exclude<WalletRiskLevel, undefined>,
  "success" | "default" | "warning" | "danger"
> = {
  HIGH: "danger",
  LOW: "success",
  MEDIUM: "warning",
  NONE: "success",
  SEVERE: "danger",
  TIMEOUT: "default",
  UNDEFINED: "default",
};
